export class BaseService {
  get cls() {
    return Object.getPrototypeOf(this).constructor
  }
}

export class BaseModelService<T> extends BaseService {
  public model!: T

  constructor(model: T) {
    super()

    this.setModel(model)
  }

  setModel(model: T) {
    this.model = model
  }
}
